module.exports = __webpack_public_path__ + "img/vue2-arriere_blanc.37f2f711.png";